module.exports = __webpack_public_path__ + "static/fish-fry-menu-b22202c4e0e7e9926f905475751be994.png";